module.exports = __webpack_public_path__ + "static/66-north-2-f8eb7586fc44b7a778160598199fd61d.jpg";